export { default } from './AccessibleSVG';
